// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## SaleNote Get
/**
 *
 * @param {{params: object, query: { saleId: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.SaleNote.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## SaleNote Create
/**
 *
 * @param {{ "plainText": "string", "isFavourite": true, "saleId": "string", "userId": "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.SaleNote.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SaleNote Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.SaleNote.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SaleNote Update
/**
 *
 * @param {{ "plainText": "string", "isFavourite": true, "saleId": "string", "userId": "string", isActive: string }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.SaleNote.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SaleNote Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.SaleNote.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
